import {
  SET_TRANSCRIPTS,
  SET_TRANSCRIPT_PAGINATION_INFO,
  SET_TRANSCRIPT,
  SHOW_TIMESTAMP,
  SET_DOWNLOAD_TYPE,
  SET_VIEW_MODE,
  SET_TRANSCRIPT_LOADING,
  UPDATE_EDITING_HISTORY,
  SET_HISTORY_INDEX,
  SET_INITIAL_TRANSCRIPT,
  SET_EDIT_MODE, SET_TOTAL_COUNT
} from "./transcriptsActions";

const initialState = {
  viewMode: 'vertical',
  editMode: 'view',
  transcripts: [],
  transcript: {
    duration: null,
    created: null,
    transcripts: [],
    confidence: 0,
    speech_time: 0
  },
  initialTranscript: {},
  paginationInfo: {
    currentPage: 1,
    perPage: 6,
    sortKey: 'created',
    sortDirection: 'desc',
  },
  totalCount: 0,
  showTimeStamp: true,
  downloadType: 'transcript',
  loading: false,
  editingHistory: [],
  currentHistoryIndex: -1
};

const transcriptsReducer = (state = initialState, action ) => {
  switch (action.type) {
    case SET_TRANSCRIPTS:
      return {
        ...state,
        transcripts: action.payload.transcripts,
        loading: false
      };
    case SET_TRANSCRIPT_PAGINATION_INFO:
      return {
        ...state,
        paginationInfo: {...action.payload.paginationInfo}
      };
    case SET_TRANSCRIPT:
      return {
        ...state,
        transcript: action.payload.transcript,
        loading: false
      };
    case SHOW_TIMESTAMP:
      return {
        ...state,
        showTimeStamp: action.payload
      };
    case SET_DOWNLOAD_TYPE:
      return {
        ...state,
        downloadType: action.payload
      };
    case SET_VIEW_MODE:
      return {
        ...state,
        viewMode: action.payload
      };
    case SET_TRANSCRIPT_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case UPDATE_EDITING_HISTORY:
      return {
        ...state,
        editingHistory: action.payload,
        currentHistoryIndex: action.payload.length - 1
      };
    case SET_HISTORY_INDEX:
      return {
        ...state,
        currentHistoryIndex: action.payload
      };
    case SET_INITIAL_TRANSCRIPT:
      return {
        ...state,
        initialTranscript: action.payload.transcript
      };
    case SET_EDIT_MODE:
      return {
        ...state,
        editMode: action.payload
      };
    case SET_TOTAL_COUNT:
      return {
        ...state,
        totalCount: action.payload
      };
    default:
      return { ...state };
  }
};

export default transcriptsReducer;
